import {
    type NodeCfg,
} from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const updateMaterialStatusUiNodeSpec: UiNodeSpec<'updateMaterialStatus'> = {
    kindLabel: 'Update Material Status',
    nodeCategory: 'argonautApi',
    requiredSockets: [ 'trigger', 'materialId' ],
    controls: getNodeCfg => {
        return {
            status: {
                nodeCfg: getNodeCfg(),
                value: getNodeCfg().controlValues.status,
                cfg: {
                    kind: 'selection',
                    items: [
                        { label: 'Completed', value: 'completed' },
                    ],
                },
            },
        };
    },
    cfg: () => {
        const materialStatusNodeCfg: NodeCfg<'updateMaterialStatus'> = {
            disabled: false,
            id: getUID(),
            kind: 'updateMaterialStatus',
            controlValues: {
                status: 'completed',
            },
        };
        return materialStatusNodeCfg;
    },
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
        materialId: { socket: 'string', label: 'Material Id' },
    }),
    outputs: () => ({
        next: { socket: 'event', label: 'Next' },
    }),
    validator: () => true,
    suppressNode: () => false,
};
